/* !
 * newsFileHref.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	// 添付ファイルリンクのURL補正
	// news_type_2 が付与された .rt_cf_n_href_news / .rt_cf_n_href_ng の相対パスを絶対パスに書き換える
	// 例) ./news_jp_file/file/AAAA.pdf → /ja/news/news_jp_file/file/AAAA.pdf
	const fixNewsFileHref = () => {
		// 接頭辞ごとの変換ルール（href が prefix で始まる場合に置換）
		const rules = [
			{ prefix: './news_jp_file/file/', replacement: '/ja/news/news_jp_file/file/' }, // 日本語サイト
			{ prefix: './news_en_file/file/', replacement: '/en/news/news_en_file/file/' }  // 英語サイト
		];

		const links = document.querySelectorAll('a.rt_cf_n_href_news.news_type_2, a.rt_cf_n_href_ng.news_type_2');

		links.forEach(link => {
			const href = link.getAttribute('href');
			if (!href) return;

			for (let i = 0; i < rules.length; i++) {
				const rule = rules[i];
				if (href.indexOf(rule.prefix) === 0) {
					link.setAttribute('href', rule.replacement + href.slice(rule.prefix.length));
					break;
				}
			}
		});
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const newsFileHrefFUNCTIONS = () => {
		fixNewsFileHref();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { newsFileHrefFUNCTIONS(); }) : newsFileHrefFUNCTIONS();

})(window.FUNCTIONS);
